// Firebase 配置文件
export const firebaseConfig = {
    apiKey: 'AIzaSyAIx72BWrP0zO90oA46WRZNHIhRikswZBI',
    authDomain: 'skygame-22a9d.firebaseapp.com',
    databaseURL: 'https://skygame-22a9d-default-rtdb.asia-southeast1.firebasedatabase.app/',
    projectId: 'skygame-22a9d',
    storageBucket: 'skygame-22a9d.firebasestorage.app',
    messagingSenderId: '85478327478',
    appId: '1:85478327478:web:01c5717f8c8638b44fd217',
    measurementId: 'G-Q3HXDXVPRK',
};

export const vapidKey = 'BIF2X67ev3lCvo9CLKYpAsLFRlZVs7FitR1ukqLi0GhMH7GPZMWdhqZtn_LMXy_u4KrRdTR7ZESGhIK5uYAUNcM';